import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}
  // canActivate(
  //   route: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return true;
  // }
  canActivate(): boolean | UrlTree {
    // 簡單檢查：如果 sessionStorage 內有 jwt_token，視為已登入
    const token = sessionStorage.getItem('jwt_token');
    if (token) {
      return true;
    }
    // 否則導回 /login
    return this.router.createUrlTree(['/login']);

    // 登出檢查
    // sessionStorage.removeItem('jwt_token');
    // this.router.navigate(['/login']);
  }
}
